import { Component, Input } from '@angular/core';
import { LotePresupuestoEstado } from 'src/app/models/entities/lote-presupuesto-estado';

@Component({
  selector: 'presupuestos-estados',
  templateUrl: './presupuestos-estados.component.html',
  styleUrls: ['./presupuestos-estados.component.scss']
})
export class PresupuestosEstadosComponent {
  @Input('lotePresupuestoEstado')
  public lotePresupuestoEstado: LotePresupuestoEstado;
  public meses: string[] = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];
  constructor(

  ) { }

}
